import { type MtssPayload } from '#app/services/ai/types.ts'
import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'

export const costaRicaMtssCitation: LegalSourceCitationBehavior<MtssPayload> = {
	title: payload => payload.title,
	url: payload => payload.url,
	inlineTagName: 'mtssdocument',
	modelAlias: { prefix: 'MTSS' },
	legacyTagNames: ['MtssDocument', 'mtss-document'],
	fallbackUrl: () => 'https://www.mtss.go.cr/temas-laborales/',
	iconName: 'briefcase-business',
	linkClassName: 'text-sky-700',
	inlineSecondaryText: payload => payload.categories.join(', '),
	summaryLabel: 'documentos MTSS',
	summaryIconName: 'briefcase-business',
	summaryIconClassName: 'text-sky-600',
	summaryDotClassName: 'bg-sky-600',
	summaryTitle: payload => payload.title,
}
